import { dateUtils } from 'shared_DEPRECATED/utils';

import {
  SESSION_RECAP_TAB_INDEX,
  TAB_INDEX_BY_TASK_TYPE_MAP,
} from 'features/controlCenter/config';
import { Task, UnreadJournalTask } from 'features/controlCenter/types';

export const taskDueOverdueTime = (dateString: string) => {
  const date = dateUtils.localDate(dateString).toDate();
  const isBefore = dateUtils().isBefore(date);

  if (isBefore) {
    const hours = dateUtils(date).diff(dateUtils().toDate(), 'hours');

    if (hours >= 72) {
      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;
      return `Due in ${days} d ${
        remainingHours > 0 ? remainingHours + ' h' : ''
      }`;
    } else if (hours >= 1) {
      return `Due in ${hours} h`;
    } else {
      const minutes = dateUtils(date).diff(dateUtils().toDate(), 'minutes');
      return `Due in ${minutes} m`;
    }
  } else {
    const hours = dateUtils().diff(date, 'hours');

    if (hours >= 72) {
      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;
      return `${days} d ${
        remainingHours > 0 ? remainingHours + ' h' : ''
      } overdue`;
    } else if (hours >= 1) {
      return `${hours} h overdue`;
    } else {
      const minutes = dateUtils().diff(date, 'minutes');
      return `${minutes} m overdue`;
    }
  }
};

export const defaultTaskTimeFormatter = (task: Task, isCompleted: boolean) => {
  if (isCompleted) {
    return dateUtils(dateUtils.localDate(task.completedAt)).timeAgoDate();
  }

  return taskDueOverdueTime(task.dueDate);
};

// a quick fix for ability to select needed tab in session recap
// depending on the tasks type we should select first, second or thrid tab
export const composeSessionRecapQueryParams = (taskType: Task['taskType']) => {
  let queryString = '';
  const tabIndex = TAB_INDEX_BY_TASK_TYPE_MAP[taskType];
  if (tabIndex && tabIndex > 0) {
    queryString = `?tab=${tabIndex}`;
  }
  return queryString;
};

export const getSessionRecapTabQueryParam = () =>
  `?tab=${SESSION_RECAP_TAB_INDEX}`;

export const calculateOldestTaskTime = (tasks: UnreadJournalTask[]) => {
  return tasks
    .map((task) => task.metadata.recordCreatedAt)
    .reduce((acc, val) => {
      if (dateUtils(val).isBefore(acc)) {
        acc = val;
      }

      return acc;
    }, dateUtils().toISOString());
};
